// Rejection text shared by the alert card, the history panel and the reasons dialog, so a
// rejected trade reads the same everywhere and raw server text never reaches the UI.

export type TradeRejectionFields = {
  reason?: string
  errorMessage?: string
  errorSource?: 'greenchart' | 'metatrader'
  errorCode?: number
}

export type TradeRejectionText = {
  text: string
  tooltip?: string
}

// SERVER_ERROR -> "Server error", MIN_LOT_SIZE -> "Min lot size"
export const formatTradeRejectReason = (code: string): string => {
  const words = code.trim().replace(/_+/g, ' ').toLowerCase()
  return words.charAt(0).toUpperCase() + words.slice(1)
}

// Broker rejections carry the broker's own message. Everything else shows only the reason code:
// the stored message for those is SDK text (URLs, request ids) and is not meant for users.
export const describeTradeRejection = (trade: TradeRejectionFields): TradeRejectionText | null => {
  if (trade.errorSource === 'metatrader' && trade.errorMessage) {
    return {
      text: `Broker error: ${trade.errorMessage}`,
      tooltip: `MT error code: ${trade.errorCode ?? 'N/A'}`,
    }
  }
  if (trade.reason) return { text: formatTradeRejectReason(trade.reason) }
  return null
}
